<template>
  <span v-if="!field.required" class="q-ml-sm all-pointer-events mw-optional-label text-italic text-caption">optional</span>
<!--  <div class="row items-center all-pointer-events mw-optional-label">-->
<!--    -->
<!--  </div>-->

</template>

<script>

export default {
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {

    };
  },

  methods: {

  },
  computed: {

  },
  mounted() {

  }
}
</script>
